import { useQuery } from '@tanstack/react-query';

import { getCapability } from '~/services/AccommodationService';

export const capabilitiesQueryKeys = {
  all: ['capabilities'] as const,
  list: () => [...capabilitiesQueryKeys.all, 'list'] as const,
  detail: (flag: string) => [...capabilitiesQueryKeys.all, 'detail', flag] as const,
};

export default function useGetCapability(flag: string) {
  return useQuery({
    queryKey: capabilitiesQueryKeys.detail(flag),
    queryFn: async ({ signal }) => {
      const response = await getCapability({ flag }, { signal });
      return response.result;
    },
    enabled: !!flag,
  });
}
